import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { tabs } from '../constants/Tabs';

import SellOffersTab from './SellOffersTab';
import BuyOffersTab from './BuyOffersTab';
import OperationsTab from './OperationsTab';

import EquityMarketAdminPanelConfiguration from './EquityMarketAdminPanelConfiguration';
import { useEquityMarketAdminPanel } from '../context/EquityMarketAdminPanelContext';

const EquityMarketAdminPanelOffersList: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useEquityMarketAdminPanel();

  const handleToggleSellTab = () => {
    actions.handleChangeTab(tabs.SELL);
  };

  const handleToggleBuyTab = () => {
    actions.handleChangeTab(tabs.BUY);
  };

  const handleToggleOperationsTab = () => {
    actions.handleChangeTab(tabs.OPERATIONS);
  };

  const handleToggleConfigTab = () => {
    actions.handleChangeTab(tabs.CONFIG);
  };

  return (
    <>
      <ul
        className="nav nav-tabs nav-tabs-s1 nav-panel-admin mb-4 d-flex flex-wrap w-100 align-items-end"
        role="tablist"
      >
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link bg-transparent ${
              data.selectedTab === tabs.SELL ? 'active' : ''
            }`}
            onClick={handleToggleSellTab}
            role="tab"
            aria-selected={data.selectedTab === tabs.SELL}
          >
            {t('SellOffers')}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link bg-transparent ${
              data.selectedTab === tabs.BUY ? 'active' : ''
            }`}
            onClick={handleToggleBuyTab}
            role="tab"
            aria-selected={data.selectedTab === tabs.BUY}
          >
            {t('BuyOffers')}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            type="button"
            className={`nav-link bg-transparent ${
              data.selectedTab === tabs.OPERATIONS ? 'active' : ''
            }`}
            onClick={handleToggleOperationsTab}
            role="tab"
            aria-selected={data.selectedTab === tabs.OPERATIONS}
          >
            {t('Operations')}
          </button>
        </li>
        <li className="nav-item ml-auto pr-0" role="presentation">
          <button
            type="button"
            className={`nav-link bg-transparent ${
              data.selectedTab === tabs.CONFIG ? 'active' : ''
            }`}
            onClick={handleToggleConfigTab}
            role="tab"
            aria-selected={data.selectedTab === tabs.CONFIG}
          >
            <em className="icon ni ni-setting mr-1" />
            {t('EquityMarketAdminConfigurationTab')}
          </button>
        </li>
      </ul>

      <div className="tab-content">
        <SellOffersTab />

        <BuyOffersTab />

        <OperationsTab />

        {/* Tab Configuración */}
        <div
          className={`tab-pane fade ${
            data.selectedTab === tabs.CONFIG ? 'show active' : ''
          }`}
          role="tabpanel"
        >
          <EquityMarketAdminPanelConfiguration
            societyId={data.societyId}
            onTogglePartnerAccess={
              actions.handleTogglePartnerEquityMarketAccess
            }
            isLoading={data.isLoading}
          />
        </div>
      </div>
    </>
  );
};

export default EquityMarketAdminPanelOffersList;
